import React from 'react';
import styled, { css } from 'styled-components';
import { StyledReactModal } from './Modal';
import { Image } from './Image';
import { ProgressiveImage } from './ProgressiveImage';
import { Icon } from './Icon';
import { Relative } from './helpers/Position';
import { pos } from '../styles/mixins';
import Expand from '../icons/solid/Expand';
const StyledImageModal = styled(StyledReactModal).withConfig({
  displayName: "ImageModal__StyledImageModal",
  componentId: "xs8qfo-0"
})(["& .Overlay{display:flex;align-content:center;justify-content:center;}& .Modal{top:unset;align-self:center;background:none;box-shadow:none;width:auto;max-width:", ";}& img{max-height:80vh;max-width:80vw;width:auto;height:100%;", ";}"], x => `calc(100vw - (${x.theme.spacer} * 4))`, x => !x.$isProgressive && css(["height:auto;"]));
const OriginalSizeIcon = styled(Icon).withConfig({
  displayName: "ImageModal__OriginalSizeIcon",
  componentId: "xs8qfo-1"
})(["position:absolute;", ";", ";z-index:1;"], pos('t', 2), pos('l', 2));
export const ImageModal = ({
  alt = '',
  closeModal,
  file,
  fileUrl,
  disableBlur = false,
  isOpen = false,
  mobile = false,
  onLoad,
  src,
  shouldCloseOnOverlayClick = true
}) => /*#__PURE__*/React.createElement(StyledImageModal, {
  $isProgressive: Boolean(file),
  $mobile: mobile,
  closeTimeoutMS: mobile ? 250 : 0,
  contentLabel: alt,
  isOpen: isOpen,
  onRequestClose: closeModal,
  role: "dialog",
  shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
}, file ? /*#__PURE__*/React.createElement(Relative, null, /*#__PURE__*/React.createElement("a", {
  href: `${fileUrl}/${file.id}.${file.extension}`,
  target: "_blank",
  rel: "noreferrer noopener"
}, /*#__PURE__*/React.createElement(OriginalSizeIcon, {
  icon: Expand,
  solid: true,
  width: "2em",
  fill: "blue",
  hoverColor: "green"
})), /*#__PURE__*/React.createElement(ProgressiveImage, {
  disableBlur: disableBlur,
  file: file,
  fileUrl: fileUrl,
  onClick: closeModal,
  onLoad: onLoad,
  placeholderSize: "xl",
  size: "xl"
})) : src ? /*#__PURE__*/React.createElement(Image, {
  src: src,
  alt: alt,
  onClick: closeModal
}) : /*#__PURE__*/React.createElement("p", null, "Geen foto gevonden"));